import { AtsQuestionOptionInput } from 'generated/resources/graphql'
import { isEmpty, set } from 'lodash'

import { FormErrors } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

interface FormValues {
  label: string
  mandatory: boolean
  autoDisqualify: boolean
  options: AtsQuestionOptionInput[]
}

export const validateQuestions = (data: FormValues, errors: FormErrors<FormValues>) => {
  if (!data.label) {
    errors.label = i18n.t('common.validations.empty')
  }

  if (
    data.autoDisqualify &&
    data.options?.every((option: AtsQuestionOptionInput) => !option.disqualifies)
  ) {
    errors.autoDisqualify = i18n.t(
      'ats.job_posting_settings.application_form.custom_questions.auto_disqualify_error'
    )
  }

  const optionErrors = data.options?.reduce(
    (err: never[], option: AtsQuestionOptionInput, index: number) => {
      if (isEmpty(option.text)) {
        set(err, `[${index}].text`, i18n.t('common.validations.empty'))
      }

      return err
    },
    []
  )

  if (optionErrors && optionErrors.length > 0) {
    errors.options = optionErrors
  }

  return errors
}
